
import { defineComponent, PropType } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faUsers,
  faGraduationCap,
  faClipboardList,
  faTerminal,
} from '@fortawesome/free-solid-svg-icons';

library.add(faUsers, faGraduationCap, faClipboardList, faTerminal);

export default defineComponent({
  name: 'EmptyState',
  components: {
    FontAwesomeIcon,
  },
  props: {
    icon: {
      type: [String, Array] as PropType<string | string[]>,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
    buttonDataAttribute: {
      type: String,
      default: '',
    },
  },
  emits: ['action'],
  computed: {
    buttonDataAttributes(): { [key: string]: string } {
      if (!this.buttonDataAttribute) {
        return {};
      }
      const attr = this.buttonDataAttribute.startsWith('data-')
        ? this.buttonDataAttribute
        : `data-${this.buttonDataAttribute}`;
      return { [attr]: '' };
    },
  },
});
